import {Flux} from '@nlabs/arkhamjs';
import {FluxProvider} from '@nlabs/arkhamjs-utils-react';
import {Metropolis} from '@nlabs/metropolisjs';
import {initI18n} from '@nlabs/metropolisjs/utils';
import {createRoot} from 'react-dom/client';

import {App} from './components/App';
import {metropolisConfig} from './lib/analytics';
import './styles/main.css';

const appContainer = document.getElementById('app');

if(!appContainer) {
  throw new Error('Missing #app root container');
}

// Gotham components suspend until translations are ready. Initialize before
// rendering so they cannot block Metropolis's own initialization effect.
initI18n({});

createRoot(appContainer).render(
  <FluxProvider flux={Flux}>
    <Metropolis config={metropolisConfig}>
      <App />
    </Metropolis>
  </FluxProvider>
);
